import axios from '@/plugins/axios-instance.js'
import appSync from '@/_services/appsync.service.js'
import gql from 'graphql-tag'

export const transportRequestService = {
  create,
  getTransportRequest,
  getTransportRequestDrop,
  createTransport,
  getTransport,
  setTransportPriority,
  setTransportPickupDelivery,
  setTransportStatus,
  setTransportIncoterms,
  setTransportComment,
  setTransportRestrictions,
  updateUnitsInTransport,
  getCargoRestrictionsEnum,
}

const url = 'https://rlzr9v3uj2.execute-api.eu-west-1.amazonaws.com/dev'

// ****************************** GETTERS ******************************
async function getTransportRequest (transportRequestID) {
  transportRequestID = transportRequestID.replace(new RegExp('/', 'g'), '%2F')
  let err = null
  let data = {}
  await axios.get(url + '/get/' + transportRequestID)
    .then(resp => {
      err = null
      data = resp.data
    })
    .catch(error => {
      err = error
    })
  return { data: data, error: err }
}

// ****************************** SETTERS ******************************
async function create (transportRequest) {
  let err = null
  axios.post(url + '/save', transportRequest)
    .then(resp => {
      err = null
    })
    .catch(error => {
      err = error
    })
  return { error: err }
}
//** Queries */

const GET_TRANSPORT = gql`query getTransport($input: GetTransportInput!) {
  getTransport(input: $input) {
    transport {
      ref
      priority
      origin {
        id
        ref
        address {
          street
          streetNo
          city
          country
          countryCode
          postalCode
        }
        organization {
          id
          ref
          name
        }
        contactPersons {
          id
          name {
            given
            middle
            family
          }
          contacts {
            type
            value
          }
        }
        openingHours {
          monday {
            morning {
              fromHours
              fromMinutes
              toHours
              toMinutes
            }
            afternoon {
              fromHours
              fromMinutes
              toHours
              toMinutes
            }
          }
          tuesday {
            morning {
              fromHours
              fromMinutes
              toHours
              toMinutes
            }
            afternoon {
              fromHours
              fromMinutes
              toHours
              toMinutes
            }
          }
          wednesday {
            morning {
              fromHours
              fromMinutes
              toHours
              toMinutes
            }
            afternoon {
              fromHours
              fromMinutes
              toHours
              toMinutes
            }
          }
          thursday {
            morning {
              fromHours
              fromMinutes
              toHours
              toMinutes
            }
            afternoon {
              fromHours
              fromMinutes
              toHours
              toMinutes
            }
          }
          friday {
            morning {
              fromHours
              fromMinutes
              toHours
              toMinutes
            }
            afternoon {
              fromHours
              fromMinutes
              toHours
              toMinutes
            }
          }
          saturday {
            morning {
              fromHours
              fromMinutes
              toHours
              toMinutes
            }
            afternoon {
              fromHours
              fromMinutes
              toHours
              toMinutes
            }
          }
          sunday {
            morning {
              fromHours
              fromMinutes
              toHours
              toMinutes
            }
            afternoon {
              fromHours
              fromMinutes
              toHours
              toMinutes
            }
          }
        }
      }
      destination {
        id
        ref
        address {
          street
          streetNo
          city
          country
          countryCode
          postalCode
        }
        organization {
          id
          ref
          name
        }
        contactPersons {
          id
          name {
            given
            middle
            family
          }
          contacts {
            type
            value
          }
        }
        openingHours {
          monday {
            morning {
              fromHours
              fromMinutes
              toHours
              toMinutes
            }
            afternoon {
              fromHours
              fromMinutes
              toHours
              toMinutes
            }
          }
          tuesday {
            morning {
              fromHours
              fromMinutes
              toHours
              toMinutes
            }
            afternoon {
              fromHours
              fromMinutes
              toHours
              toMinutes
            }
          }
          wednesday {
            morning {
              fromHours
              fromMinutes
              toHours
              toMinutes
            }
            afternoon {
              fromHours
              fromMinutes
              toHours
              toMinutes
            }
          }
          thursday {
            morning {
              fromHours
              fromMinutes
              toHours
              toMinutes
            }
            afternoon {
              fromHours
              fromMinutes
              toHours
              toMinutes
            }
          }
          friday {
            morning {
              fromHours
              fromMinutes
              toHours
              toMinutes
            }
            afternoon {
              fromHours
              fromMinutes
              toHours
              toMinutes
            }
          }
          saturday {
            morning {
              fromHours
              fromMinutes
              toHours
              toMinutes
            }
            afternoon {
              fromHours
              fromMinutes
              toHours
              toMinutes
            }
          }
          sunday {
            morning {
              fromHours
              fromMinutes
              toHours
              toMinutes
            }
            afternoon {
              fromHours
              fromMinutes
              toHours
              toMinutes
            }
          }
        }
      }
      pickup {
        from
        to
      }
      delivery {
        from
        to
      }
      unitsCount {
        type
        count
      }
      weight
      volume
      incoterms
      restrictions {
        cargo
        vehicle
        location
      }
      comment
      status
      units {
        id
        ref
        type
        # transport {
        #   id
        #   ref
        #   order {
        #     buyer {
        #       organization {
        #         id
        #         ref
        #         name
        #       }
        #       reference
        #     }
        #     seller {
        #       organization {
        #         id
        #         ref
        #         name
        #       }
        #       reference
        #     }
        #   }
        # }
        parent
        weight
        packagingWeight
        isLeaf
        status
        dimensions {
          length
          height
          width
        },
        items {
          ref
          category
          name
          weight
        },
      }
      order {
        buyer {
          organization {
            id
            ref
            name
          }
          ref
        }
        seller {
          organization {
            id
            ref
            name
          }
          ref
        }
      }
      drops {
        shipment
      }
      createdAt
      updatedAt
    }
  }
}`

const GET_TRANSPORT_DROP = gql`query getTransport($input: GetTransportInput!) {
  getTransport(input: $input) {
    transport {
      drops {
        shipment
        id
      }
    }
  }
}`

async function getTransport ({ id }) {
  try {
    const response = await appSync.query({
      query: GET_TRANSPORT,
      variables: {
        input: {
          id
        }
      },
      fetchPolicy: 'no-cache'
    })
    return response.data.getTransport.transport
  } catch (error) {
    return Promise.reject(error)
  }
}

async function getTransportRequestDrop ({ id }) {
  try {
    const response = await appSync.query({
      query: GET_TRANSPORT_DROP,
      variables: {
        input: {
          id
        }
      },
      fetchPolicy: 'no-cache'
    })
    return response.data.getTransport.transport
  } catch (error) {
    return Promise.reject(error)
  }
}

//*** Mutations */
const CREATE_TRANSPORT = gql`mutation createTransport($input: CreateTransportInput!) {
  createTransport(input: $input) {
    id,
    units {
      id
      ref
    },
    # err
  }
}`

const SET_TRANSPORT_PRIORITY = gql`mutation setTransportPriority($input: SetTransportPriorityInput!) {
  setTransportPriority(input: $input) {
    err
  }
}`

const SET_TRANSPORT_STATUS = gql`mutation setTransportStatus($input: SetTransportStatusInput!) {
  setTransportStatus(input: $input) {
    err
  }
}`

const SET_TRANSPORT_INCOTERMS = gql`mutation setTransportIncoterms($input: SetTransportIncotermsInput!) {
  setTransportIncoterms(input: $input) {
    err
  }
}`

const SET_TRANSPORT_COMMENT = gql`mutation setTransportComment($input: SetTransportCommentInput!) {
  setTransportComment(input: $input) {
    err
  }
}`

const SET_TRANSPORT_PICKUP = gql`mutation setTransportPickup($input: SetTransportPickupInput!) {
  setTransportPickup(input: $input) {
    err
  }
}`

const SET_TRANSPORT_DELIVERY = gql`mutation setTransportDelivery($input: SetTransportDeliveryInput!) {
  setTransportDelivery(input: $input) {
    err
  }
}`

const ADD_UNITS_TO_TRANSPORT = gql`mutation addUnitsToTransport($input: AddUnitsToTransportInput!) {
  addUnitsToTransport(input: $input) {
    units
    err
  }
}`

const REMOVE_UNITS_FROM_TRANSPORT = gql`mutation removeUnitsFromTransport($input: RemoveUnitsFromTransportInput!) {
  removeUnitsFromTransport(input: $input) {
    err
  }
}`

const SET_TRANSPORT_RESTRICTIONS = gql`mutation setTransportRestrictions($input: SetTransportRestrictionsInput!) {
  setTransportRestrictions(input: $input) {
    err
  }
}`

async function createTransport ({ ref, origin, destination, labels, pickup, delivery, incoterms, priority, status, order, comment, restrictions, units }) {
  try {

    const response = await appSync.mutate({
      mutation: CREATE_TRANSPORT,
      variables: {
        input: {
          ref,
          origin,
          destination,
          labels,
          pickup,
          delivery,
          incoterms,
          priority,
          status,
          order,
          comment,
          restrictions,
          units
        }
      },
      fetchPolicy: 'no-cache'
    })
    return response
  } catch (error) {
    return Promise.reject(error)
  }
}

async function setTransportPriority ({ transportID, value }) {
  try {
    const response = await appSync.mutate({
      mutation: SET_TRANSPORT_PRIORITY,
      variables: {
        input: {
          transport: transportID,
          priority: value.value
        }
      },
      fetchPolicy: 'no-cache'
    })
    return response.data.setTransportPriority
  } catch (error) {
    return Promise.reject(error)
  }
}

async function setTransportStatus ({ transportID, value }) {
  try {
    const response = await appSync.mutate({
      mutation: SET_TRANSPORT_STATUS,
      variables: {
        input: {
          transport: transportID,
          status: value.value
        }
      },
      fetchPolicy: 'no-cache'
    })
    return response.data.setTransportStatus
  } catch (error) {
    return Promise.reject(error)
  }
}

async function setTransportIncoterms ({ transportID, value }) {
  try {
    const response = await appSync.mutate({
      mutation: SET_TRANSPORT_INCOTERMS,
      variables: {
        input: {
          transport: transportID,
          incoterms: value.id
        }
      },
      fetchPolicy: 'no-cache'
    })
    return response.data.setTransportIncoterms
  } catch (error) {
    return Promise.reject(error)
  }
}

async function setTransportComment ({ transportID, value }) {
  try {
    const response = await appSync.mutate({
      mutation: SET_TRANSPORT_COMMENT,
      variables: {
        input: {
          transport: transportID,
          comment: value
        }
      },
      fetchPolicy: 'no-cache'
    })
    return response.data.setTransportComment
  } catch (error) {
    return Promise.reject(error)
  }
}

async function updateUnitsInTransport ({ transportID, added, removed }) {
  try {
    let newIDs
    if (added.length > 0) {
      let addedUnits = [...added]
      for (let i = 0; i < addedUnits.length; i++) {
        delete addedUnits[i].id
        delete addedUnits[i].newCreated
      }
      const response = await appSync.mutate({
        mutation: ADD_UNITS_TO_TRANSPORT,
        variables: {
          input: {
            transport: transportID,
            units: addedUnits
          }
        },
        fetchPolicy: 'no-cache'
      })
      newIDs = response.data.addUnitsToTransport.units
      // return response.data.setTransportComment
    }
    if (removed.length > 0) {
      await appSync.mutate({
        mutation: REMOVE_UNITS_FROM_TRANSPORT,
        variables: {
          input: {
            transport: transportID,
            units: removed
          }
        },
        fetchPolicy: 'no-cache'
      })
    }
    return newIDs
  } catch (error) {
    return Promise.reject(error)
  }
}

async function setTransportRestrictions ({ transportID, value }) {
  try {
    console.log(value)
    // const response = await appSync.mutate({
    //   mutation: SET_TRANSPORT_RESTRICTIONS,
    //   variables: {
    //     input: {
    //       transport: transportID,
    //       restrictions: value
    //     }
    //   },
    //   fetchPolicy: 'no-cache'
    // })
    // return response.data.setTransportRestrictions
  } catch (error) {
    return Promise.reject(error)
  }
}

async function setTransportPickupDelivery ({ transportID, transport }) {
  try {
    console.log(transport)
    const response = await appSync.mutate({
      mutation: SET_TRANSPORT_PICKUP,
      variables: {
        input: {
          transport: transportID,
          location: transport.origin.id,
          from: transport.pickup.from,
          to: transport.pickup.to
        }
      },
      fetchPolicy: 'no-cache'
    })
    await appSync.mutate({
      mutation: SET_TRANSPORT_DELIVERY,
      variables: {
        input: {
          transport: transportID,
          location: transport.destination.id,
          from: transport.delivery.from,
          to: transport.delivery.to
        }
      },
      fetchPolicy: 'no-cache'
    })
    return response.data.setTransportPriority
  } catch (error) {
    return Promise.reject(error)
  }
}

/** ENUMS */
const GET_CARGO_RESTRICTIONS_ENUMS = gql`query {
  __type(name: "CargoRestrictions") {
     name
     enumValues {
       name
     }
   }
 }`
async function getCargoRestrictionsEnum () {
  try {
    const response = await appSync.query({
      query: GET_CARGO_RESTRICTIONS_ENUMS,
      fetchPolicy: 'cache'
    })
    return response.data.__type.enumValues
  } catch (error) {
    return Promise.reject(error)
  }
}
